import { render, staticRenderFns } from "./ColumnToShow.vue?vue&type=template&id=6a7823a1"
import script from "./ColumnToShow.vue?vue&type=script&lang=js"
export * from "./ColumnToShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports